import { state, props, resolveObject } from 'cerebral/tags'
import { set } from 'cerebral/operators'
import { parallel } from 'cerebral'
import sendOrder from '../actions/sendOrder'
import isOrderValid from '../actions/isOrderValid'
import createSnackbar from 'modules/App/factories/createSnackbar'
import setBasketReceivers from 'modules/App/actions/setBasketReceivers'
import loadMyOrderHistory from 'modules/OrderHistory/chains/loadMyOrderHistory'

export default [
  isOrderValid,
  {
    true: [
      parallel('Send order', [
        sendOrder,
        set(state`basket.orderId`, null),
        set(state`basket.basketItems`, {}),
        set(state`basket.message.value`, ''),
        setBasketReceivers
      ]),
      ...loadMyOrderHistory
    ],
    false: [
      createSnackbar(
        resolveObject({
          key: 'bms.orderBasket.errors.numErrors',
          params: resolveObject({ count: props`numErrors` })
        }),
        'error'
      )
    ],
    receivers: [
      createSnackbar({ key: 'bms.orderBasket.errors.noReceivers' }, 'error')
    ]
  }
]



// WEBPACK FOOTER //
// ./src/modules/Basket/chains/sendOrder.js